var _path, _mask, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLavanderia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M43.462 24.484c-.85 0-1.539-.69-1.539-1.539V6.385c0-1.273-1.035-2.308-2.308-2.308h-29.23c-1.273 0-2.308 1.035-2.308 2.308v6.723c0 .85-.69 1.538-1.539 1.538S5 13.958 5 13.108V6.385C5 3.415 7.415 1 10.385 1h29.23C42.585 1 45 3.415 45 6.385v16.56c0 .85-.69 1.539-1.538 1.539",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "wymafb5p2a",
    width: 40,
    height: 28,
    x: 5,
    y: 22,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5 22.85h40v26.61H5V22.85z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#wymafb5p2a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M39.615 49.46h-29.23C7.415 49.46 5 47.046 5 44.077V24.389c0-.85.69-1.538 1.538-1.538.85 0 1.539.688 1.539 1.538v19.687c0 1.272 1.035 2.308 2.308 2.308h29.23c1.273 0 2.308-1.036 2.308-2.308v-5.44c0-.85.69-1.54 1.538-1.54.85 0 1.539.69 1.539 1.54v5.44c0 2.97-2.415 5.385-5.385 5.385",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M43.462 19.462H11.923c-.849 0-1.538-.69-1.538-1.539s.689-1.538 1.538-1.538h31.539c.849 0 1.538.689 1.538 1.538 0 .85-.69 1.539-1.538 1.539M36.538 12.539h-7.692c-.85 0-1.538-.69-1.538-1.539s.689-1.538 1.538-1.538h7.692c.85 0 1.539.69 1.539 1.538 0 .85-.69 1.539-1.539 1.539M18.077 12.539h-3.846c-.85 0-1.539-.69-1.539-1.539s.69-1.538 1.539-1.538h3.846c.85 0 1.538.69 1.538 1.538 0 .85-.689 1.539-1.538 1.539M25.384 26.77c-3.393 0-6.154 2.76-6.154 6.153s2.761 6.154 6.154 6.154 6.154-2.76 6.154-6.154c0-3.393-2.76-6.153-6.154-6.153m0 15.384c-5.09 0-9.23-4.14-9.23-9.23 0-5.09 4.14-9.231 9.23-9.231 5.09 0 9.23 4.14 9.23 9.23 0 5.09-4.14 9.231-9.23 9.231",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavanderia);
export default __webpack_public_path__ + "static/media/lavanderia.39895d68cd3d9709facfb728ae521989.svg";
export { ForwardRef as ReactComponent };